<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold py-5">{{ 'v3-byoc-popup-create-episode-fetch-title' | translate }}</div>
    </div>

    <div class="px-4 mb-4 flex-grow-1">
        <input
            [ariaLabel]="'v3-byoc-popup-create-episode-fetch-title' | translate"
            class="w-100 success mb-1"
            type="text"
            [formControl]="control"
            [ngClass]="{ 'danger-solid danger-solid-focus': control.invalid && control.dirty }"
            [placeholder]="'v3-byoc-popup-create-episode-link-input-placeholder' | translate"
            formControlDataTest="episodeLinkInput"
        />
    </div>

    <div class="theme-new d-flex align-items-center px-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button
            [ariaDisabled]="control.invalid"
            (click)="nextClick()"
            class="btn btn-secondary"
            [ngClass]="[control.invalid ? 'btn-disabled' : 'btn-secondary']"
            translate
            buttonDataTest="submitButton"
        >
            v3-button-submit
        </button>
    </div>
</div>
